import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initGA, logPageView } from '../analytics/index';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location.pathname]);

  return null;
};

export default Analytics;
